import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-plan-required-form',
  templateUrl: './plan-required-form.component.html',
  styleUrls: ['./plan-required-form.component.css']
})
export class PlanRequiredFormComponent implements OnInit, OnDestroy {

  @Input() isInPopup = false;
  @Output() changeScreen: EventEmitter<any> = new EventEmitter<any>();
  @Input() message = '';
  public processing = false;
  public buttonWasClicked = false;

  public formData = {
    error: '',
    message: ''
  };

  constructor( private router: Router) {
  }

  ngOnInit(): void {
    const that = this;
    if (that.isInPopup && that.message) {
      that.formData.message = that.message;
    }
  }

  ngOnDestroy(): void {
  }

  public buttonClickHandler(): void {
    const that = this;
    if (!that.processing) {
      if (!that.buttonWasClicked) {
        that.processing = true;
        const url = that.router.serializeUrl(that.router.createUrlTree(['planes']));
        window.open(url, '_blank');
        that.buttonWasClicked = true;
        that.processing = false;
      } else {
        window.location.reload();
      }
    }
  }
}
